/* global femcare */

femcare.ageVerification.verification = {
    /**
     * Handles age verification form in the modal.
     * Retrieves the age limit and redirect URL from the modal’s data attributes,
     * and handles form submissions by either hiding the modal or redirecting the user based on the entered age.
     */
    init() {
        const ageVerificationContainer = document.querySelector('.age-verification');
        const ageVerificationModal = document.querySelector('.modal--age-verification');

        if (ageVerificationContainer && ageVerificationModal) {
            const ageLimit = Number(ageVerificationContainer.dataset.ageLimit) || 0;
            const redirectUrl = ageVerificationContainer.dataset.redirectUrl || '/';
            const form = document.getElementById('ageVerificationForm');

            form.addEventListener('submit', (event) => {
                event.preventDefault();
                const ageInput = form.querySelector('input[name="age"]');
                const age = ageInput ? Number(ageInput.value) : 0;

                if (age >= ageLimit) {
                    ageVerificationModal.classList.remove('displayed');
                } else {
                    window.location.href = redirectUrl;
                }
            });
        }
    }
};
